var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "TransferBots" }, [
    _c("header", { staticClass: "TransferBots__Header" }, [
      _c("h1", [_vm._v("סטטוס בוטי הסבות")]),
      _vm.lastPollAt
        ? _c("div", { staticClass: "TransferBots__Header__Meta" }, [
            _vm._v(
              " עודכן: " +
                _vm._s(_vm.formatDateTimeWithSeconds(_vm.lastPollAtIso)) +
                " "
            )
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "TransferBots__Header__Actions" },
        [
          _c(
            "b-button",
            {
              attrs: {
                type: "is-success",
                "icon-left": "play",
                loading: _vm.bulkActionInFlight === "start",
                disabled: !_vm.ready || _vm.bulkActionInFlight !== null
              },
              on: { click: _vm.handleStartAll }
            },
            [_vm._v("הפעל הכל")]
          ),
          _c(
            "b-button",
            {
              attrs: {
                type: "is-danger",
                "icon-left": "stop",
                loading: _vm.bulkActionInFlight === "stop",
                disabled: !_vm.ready || _vm.bulkActionInFlight !== null
              },
              on: { click: _vm.handleStopAll }
            },
            [_vm._v("עצור הכל")]
          )
        ],
        1
      )
    ]),
    _c(
      "section",
      { staticClass: "TransferBots__Cubes" },
      [
        _vm._l(_vm.visibleCubes, function(bot) {
          return _c(
            "div",
            {
              key: bot.key,
              staticClass: "Cube",
              class: _vm.cubeColorClass(bot)
            },
            [
              _c(
                "header",
                { staticClass: "Cube__Header" },
                [
                  _c("span", { staticClass: "Cube__Dot" }),
                  _c("span", { staticClass: "Cube__Name" }, [
                    _vm._v(_vm._s(bot.label))
                  ]),
                  _c("span", { staticClass: "Cube__State" }, [
                    _vm._v(_vm._s(_vm.stateLabel(bot)))
                  ]),
                  _vm.canStart(bot) || _vm.canStop(bot)
                    ? _c(
                        "b-dropdown",
                        {
                          attrs: {
                            position: "is-bottom-left",
                            "aria-role": "list"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "trigger",
                                fn: function(ref) {
                                  var active = ref.active
                                  return [
                                    _c("b-button", {
                                      staticClass: "Cube__MenuBtn",
                                      attrs: {
                                        size: "is-small",
                                        "icon-right": active
                                          ? "menu-up"
                                          : "dots-vertical",
                                        loading: _vm.actionInFlight === bot.key
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm.canStart(bot)
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "aria-role": "listitem" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleStart(bot)
                                    }
                                  }
                                },
                                [_vm._v("הפעל")]
                              )
                            : _vm._e(),
                          _vm.canStop(bot)
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "aria-role": "listitem" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleStop(bot)
                                    }
                                  }
                                },
                                [_vm._v("עצור")]
                              )
                            : _vm._e(),
                          bot.supportsRestart && _vm.canStop(bot)
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "aria-role": "listitem" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleRestart(bot)
                                    }
                                  }
                                },
                                [_vm._v("הפעל מחדש")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              bot.municipalities
                ? _c("div", { staticClass: "Cube__Subtitle" }, [
                    _vm._v(" " + _vm._s(bot.municipalities.join(", ")) + " ")
                  ])
                : _vm._e(),
              bot.hostReachable && bot.status
                ? _c("div", { staticClass: "Cube__Body" }, [
                    bot.status.currentReportNumber
                      ? _c("div", { staticClass: "Cube__Row" }, [
                          _c("span", [_vm._v("דוח נוכחי:")]),
                          _c("strong", [
                            _vm._v(_vm._s(bot.status.currentReportNumber))
                          ])
                        ])
                      : _vm._e(),
                    bot.status.transfersCompleted != null
                      ? _c("div", { staticClass: "Cube__Row" }, [
                          _c("span", [_vm._v("הושלמו:")]),
                          _c("strong", [
                            _vm._v(_vm._s(bot.status.transfersCompleted))
                          ])
                        ])
                      : _vm._e(),
                    bot.status.transfersFailed != null
                      ? _c("div", { staticClass: "Cube__Row" }, [
                          _c("span", [_vm._v("נכשלו:")]),
                          _c("strong", [
                            _vm._v(_vm._s(bot.status.transfersFailed))
                          ])
                        ])
                      : _vm._e(),
                    bot.status.startedAt
                      ? _c(
                          "div",
                          { staticClass: "Cube__Row Cube__Row--date" },
                          [
                            _c("span", [_vm._v("התחלה:")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.formatDateTime(bot.status.startedAt))
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    bot.status.lastActivity
                      ? _c(
                          "div",
                          { staticClass: "Cube__Row Cube__Row--date" },
                          [
                            _c("span", [_vm._v("פעילות אחרונה:")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDateTime(bot.status.lastActivity)
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    bot.status.nextPollAt
                      ? _c(
                          "div",
                          { staticClass: "Cube__Row Cube__Row--date" },
                          [
                            _c("span", [_vm._v("הרצה הבאה:")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.countdown(bot.status.nextPollAt))
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    bot.status.waitingForHumanReason
                      ? _c("div", { staticClass: "Cube__Row" }, [
                          _c("span", [_vm._v("סיבה:")]),
                          _c("strong", [
                            _vm._v(_vm._s(bot.status.waitingForHumanReason))
                          ])
                        ])
                      : _vm._e()
                  ])
                : _c(
                    "div",
                    { staticClass: "Cube__Body Cube__Body--Unreachable" },
                    [_vm._v(" הבוט אינו מגיב כרגע. ")]
                  )
            ]
          )
        }),
        !_vm.sharedServiceReachable
          ? _c("div", { staticClass: "Cube Cube--SharedDown" }, [
              _vm._m(0),
              _c("div", { staticClass: "Cube__Body" }, [
                _vm._v(_vm._s(_vm.sharedDownTooltip))
              ])
            ])
          : _vm._e()
      ],
      2
    ),
    _c(
      "section",
      { staticClass: "TransferBots__Api" },
      [
        _c(
          "div",
          { staticClass: "TransferBots__Api__Header" },
          [
            _c("h2", [_vm._v("הסבות API")]),
            _c(
              "b-button",
              {
                attrs: {
                  type: "is-danger",
                  "icon-left": "stop",
                  loading: _vm.apiActionInFlight === "stop",
                  disabled: _vm.apiActionInFlight !== null
                },
                on: { click: _vm.handleStopApiTransfers }
              },
              [_vm._v("הפסק הכל")]
            )
          ],
          1
        ),
        _c("p", { staticClass: "TransferBots__Api__Description" }, [
          _vm._v(
            " הסבות API הן הסבות אשר מוגדרות לצאת דרך API ואין דרך לדעת את הסטטוס עליהן. אם לא בטוחים עדיף להפסיק הכל ולהפעילן שוב כדי לנקות את רשימת ההסבות. "
          )
        ]),
        _vm._l(_vm.apiTransferRows, function(row) {
          return _c("div", { key: row.type, staticClass: "ApiRow" }, [
            _c("span", { staticClass: "ApiRow__Label" }, [
              _vm._v(_vm._s(row.label))
            ]),
            _c(
              "div",
              { staticClass: "ApiRow__Actions" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      type: "is-success",
                      "icon-left": "play",
                      loading: _vm.apiActionInFlight === "start-" + row.type,
                      disabled: _vm.apiActionInFlight !== null
                    },
                    on: {
                      click: function($event) {
                        return _vm.handleStartApiTransfers(row.type)
                      }
                    }
                  },
                  [_vm._v("הפעל")]
                )
              ],
              1
            )
          ])
        })
      ],
      2
    ),
    _c(
      "section",
      { staticClass: "TransferBots__Rdp" },
      [
        _c("h2", [_vm._v("חיבור למכונת הסבות")]),
        _c(
          "b-tabs",
          {
            attrs: { type: "is-boxed" },
            model: {
              value: _vm.activeRdpTab,
              callback: function($$v) {
                _vm.activeRdpTab = $$v
              },
              expression: "activeRdpTab"
            }
          },
          _vm._l(_vm.rdpSessions, function(session) {
            return _c(
              "b-tab-item",
              { key: session.key, attrs: { label: session.label } },
              [
                _c(
                  "div",
                  { staticClass: "RdpTab" },
                  [
                    _c("p", [
                      _vm._v("פתח את שולחן העבודה המרוחק בלשונית חדשה.")
                    ]),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          type: "is-primary",
                          "icon-left": "open-in-new",
                          tag: "a",
                          href: session.url,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }
                      },
                      [_vm._v("פתח חיבור - " + _vm._s(session.label))]
                    )
                  ],
                  1
                )
              ]
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "Cube__Header" }, [
      _c("span", { staticClass: "Cube__Dot" }),
      _c("span", { staticClass: "Cube__Name" }, [
        _vm._v("שירות הבוטים המשותף")
      ]),
      _c("span", { staticClass: "Cube__State" }, [_vm._v("לא זמין")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }